import Link from 'next/link';
import Image from 'next/future/image';
import { useState } from 'react';
import cn from 'classnames';
import { priceFormater } from '@/settings';
import { calculateSavings, getOfferUri } from '@/lib/offer';
import { ConditionPopup } from '@/components/products/conditionPopup/ConditionPopup';
import { TopDealProduct } from '@/lib/hot-deals/helpers';
import { TopDealProduct as NewTopDealProduct } from '@/components/collections/hotDeals/getServerSideProps';
import infoIconBlack from '@/public/icons/product/infoIconBlack.svg';

const HotDealCard = ({
  deal,
  isSlider = false,
}: {
  index: number;
  deal: TopDealProduct | NewTopDealProduct;
  isSlider?: boolean;
}) => {
  const [isConditionPopupOpen, setIsConditionPopupOpen] = useState(false);
  const [activeCondition, setActiveCondition] = useState({
    condition: '',
    isSmartphone: false,
    category: '',
    categoryPk: '',
  });

  const savingsPercentage = calculateSavings(deal.price, deal.comparePrice);
  const isSmartphone = deal.productType === 'Smartphones';

  return (
    <>
      <Link href={getOfferUri(deal as any)} passHref key={deal.gid}>
        <a
          // eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values
          className={cn(
            'flex cursor-pointer flex-col justify-between border bg-white p-5 text-xs',
            {
              'h-full rounded-md': isSlider,
              '-ml-[1px] -mt-[1px] border-gray-200 hover:z-10 hover:border-black/10':
                !isSlider,
            },
          )}
        >
          <div>
            <div className="relative mb-5 min-h-[100px]">
              <Image
                src={deal.imageUrl}
                alt={deal.title}
                fill
                className="object-contain"
                priority
              />
            </div>
            <div>
              <h3
                // eslint-disable-next-line tailwindcss/no-custom-classname
                className="two-line-ellipsis text-sm"
              >
                {deal.title.replace(/Oppo/g, 'OPPO')}
              </h3>
            </div>
            <div className="mt-1 flex items-center">
              <span className="mr-1">
                {deal.condition?.replace('Very Good', 'Good')} Condition
              </span>
              <button
                className="p-2"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveCondition({
                    condition: deal.condition ?? 'Premium',
                    isSmartphone,
                    category: deal.productType || '',
                    categoryPk: deal.categoryPks?.[0] || '',
                  });
                  setIsConditionPopupOpen(true);
                }}
              >
                <Image
                  src={infoIconBlack}
                  alt="Condition"
                  width={14}
                  height={14}
                  className="object-contain"
                />
              </button>
            </div>
          </div>
          <div className="mt-5 flex flex-wrap-reverse items-end justify-between gap-x-3 gap-y-1">
            <div>
              <h3 className="text-sm font-bold">
                {priceFormater.long(deal.price)}
              </h3>
              {deal.comparePrice != null && savingsPercentage > 3 && (
                <h4 className="text-xs text-gray-700/30">
                  new{' '}
                  <span className="line-through">
                    {priceFormater.long(deal.comparePrice)}
                  </span>
                </h4>
              )}
            </div>
            {savingsPercentage > 3 && (
              <div className="place-self-end rounded bg-red px-2.5 py-1 text-xs text-white">
                Save {savingsPercentage}%
              </div>
            )}
          </div>
        </a>
      </Link>
      <ConditionPopup
        activeCondition={activeCondition.condition}
        isOpen={isConditionPopupOpen}
        onClose={() => setIsConditionPopupOpen(false)}
        categoryPk={activeCondition.categoryPk}
      />
    </>
  );
};

export default HotDealCard;
